export const API_URL = process.env.VUE_APP_BACKEND_URL || ''
export const LANGUAGE = process.env.VUE_APP_LANGUAGE
export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY
export const RECAPTCHA_SITE_SECRET = process.env.VUE_APP_RECAPTCHA_SITE_SECRET
export const SENTRY_API = process.env.VUE_APP_SENTRY_API
export const ANALYTICS_KEY = process.env.VUE_APP_ANALYTICS_KEY
export const MAINTENANCE_WINDOW = process.env.VUE_APP_MAINTENANCE_WINDOW
export const DOMAIN = process.env.VUE_APP_DOMAIN

/** When API_URL is empty, devServer proxy — rewrite absolute backend URLs to same-origin paths. */
export function resolveApiUrl (url) {
  if (!url || API_URL) return url
  try {
    const parsed = new URL(url)
    return `${parsed.pathname}${parsed.search}`
  } catch (e) {
    return url
  }
}
